import { useState, useEffect, createContext } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from "axios";
import API from '../utils/api';

const AuthContext = createContext();

const AuthProvider = ({children}) => {

    const [auth, setAuth] = useState({})
    const [cargando, setCargando] = useState(true)
    
    

    const navigate = useNavigate()

    useEffect(() => {
        const autenticarUsuario = async () => {
            const perfil = localStorage.getItem('perfil')
            const token = localStorage.getItem('token')
            if(!token){
                setCargando(false)
                return
            }

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}` 
                }
            }

            try {
                console.log(config)
                var url = API.urlAPI
                const urlPerfil = url + 'usuarios/perfil'
                const { data } = await axios(urlPerfil, config)
                setAuth(data)
                navigate('prestamos/')

            } catch (error) {
                setAuth({})
            } 

            setCargando(false)

            
        }
        autenticarUsuario()
    }, [])

    const cerrarSesionAuth = () => {
        setAuth({})
    }


    return (
        <AuthContext.Provider
            value={{
                auth,
                setAuth,
                cargando,
                cerrarSesionAuth
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export { 
    AuthProvider
}

export default AuthContext;